import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "../../ui";

interface SidebarSubItemProps {
  faIcon?: IconProp;
  imgSrc?: string;
  label: string;
  onClick?: () => void;
}

export function SidebarSubItem({
  faIcon,
  imgSrc,
  label,
  onClick,
}: SidebarSubItemProps) {
  return (
    <Button
      onClick={onClick}
      className="w-full flex items-center gap-3 px-4 py-1.5 text-gray-300 hover:bg-[#1f1f1f]"
    >
      {faIcon && <FontAwesomeIcon icon={faIcon} />}
      {imgSrc && <img src={imgSrc} alt={label} className="w-8 h-8" />}
      <span>{label}</span>
    </Button>
  );
}
